import BaseService from 'services/BaseService';
import LinkHelper from 'util/LinkHelper';

const linkhelper = new LinkHelper();

class InsightsMonthlyService extends BaseService {
    constructor() {
        let apiName = 'ProductAnalyticsMonthlyDataAPI';

        let tenantApiName = 'TenantManagementServiceAPI';

        let collectionPath = '/monthly';

        super(apiName, tenantApiName, collectionPath);
    }

    async getTenantId() {
        if (linkhelper.getCurAuthTenandid() !== null) {
            return {
                'pac-selected-tenant-id': linkhelper.getCurAuthTenandid(),
                'pac-selected-tenant-icao': linkhelper.getCurAuthTenantIcao()
            };
        }

        return null;
    }

    async getAdminTenantId(icao) {
        if (linkhelper.getCurAuthTenandid() !== null) {
            let header = { 'pac-selected-tenant-id': linkhelper.getCurAuthTenandid() };
            if (icao) {
                header['pac-selected-tenant-icao'] = icao;
            }

            return header;
        }

        return null;
    }

    async fetchFilterValuesAxios(params, cancelRequestToken) {
        let path = process.env.REACT_APP_INSIGHTS_API_URL + `/v2/metrics/filter_values`;

        let headers;
        let queryStringParameters;

        if (window.sessionStorage.getItem('all_tenants_view') === 'true') {
            let tenant = JSON.parse(sessionStorage.getItem('all_tenant_view_selected_tenant'));
            headers = {
                'pac-selected-tenant-id': tenant.value,
                'pac-selected-tenant-icao': tenant.icaoCode,
                admin_api_name: 'filters'
            };
            path = process.env.REACT_APP_INSIGHTS_API_URL + `/v2/admin/all_airlines_data`;
            if (tenant.icaoCode === 'all') {
                headers['pac-selected-tenant-id'] = '903a42bc-985e-40d1-2222-32b8c2e33397';
            }
        } else {
            await this.getTenantId().then((response) => {
                headers = response;
            });
        }

        queryStringParameters = params;

        let options = {
            headers: headers,
            cancelToken: cancelRequestToken,
            params: queryStringParameters
        };

        if (options.headers) {
            options.headers.Authorization = await this.getAuthorizationHeader();
        }

        if (window.sessionStorage.getItem('all_tenants_view') == 'true') {
            return this.makePostApiCallAxios(path, {}, options);
        } else {
            return this.makeGetApiCallAxios(path, options);
        }
    }

    async fetchAdminTenantsAxios(app, subscription, cancelRequestToken) {
        let tenant = JSON.parse(sessionStorage.getItem('all_tenant_view_selected_tenant'));
        let headers = {
            'pac-selected-tenant-id': tenant.value,
            'pac-selected-tenant-icao': tenant.icaoCode,
            admin_api_name: 'filters'
        };
        let path = process.env.REACT_APP_INSIGHTS_API_URL + `/v2/admin/all_airlines_data`;
        if (tenant.icaoCode === 'all') {
            headers['pac-selected-tenant-id'] = '903a42bc-985e-40d1-2222-32b8c2e33397';
        }

        let queryStringParameters = {
            translation_language: 'en-us',
            requested_filters: 'paxus_offload_airlines,regions',
            tier: subscription
        };

        if (app !== 'Overview') {
            queryStringParameters['app'] = app;
        }

        let options = {
            headers: headers,
            cancelToken: cancelRequestToken,
            params: queryStringParameters
        };

        if (options.headers) {
            options.headers.Authorization = await this.getAuthorizationHeader();
        }

        return this.makePostApiCallAxios(path, {}, options);
    }

    async fetchAdminLiveTVChannelsAxios(data, subscription, cancelRequestToken) {
        let headers = {};

        let path = process.env.REACT_APP_INSIGHTS_API_URL + `/v2/admin/all_airlines_data`;

        headers['admin_api_name'] = 'live_tv_channel';

        let options = {
            headers: headers,
            cancelToken: cancelRequestToken
        };

        if (options.headers) {
            options.headers.Authorization = await this.getAuthorizationHeader();
        }

        return this.makePostApiCallAxios(path, data, options);
    }

    async fetchSubscriptionData() {
        let path = `/v2/info/subscription_info`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        if (headers && headers['pac-selected-tenant-icao'] === 'all') {
            headers['pac-selected-tenant-icao'] = 'pac';
        }

        let options = {
            body: {},
            headers: headers
        };

        return new Promise((resolve, reject) => {
            this.makePostApiCall(this.apiName, path, options).then((response) => {
                if (response) {
                    return resolve(response);
                } else {
                    return reject(response);
                }
            });
        });
    }

    async addUpdateLicense(payload, cancelRequestToken) {
        let path = '/v2/admin/update_license_acl';
        let headers;
        await this.getAdminTenantId(payload.icao).then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        return this.postAdminAxios(path, payload, options, cancelRequestToken);
    }

    async addUpdateDeleteTails(payload, cancelRequestToken) {
        let path = '/v2/admin/update_tails';
        let headers;
        await this.getAdminTenantId(payload.icao).then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        return this.postAdminAxios(path, payload, options, cancelRequestToken);
    }

    async fetchAirlines(payload, cancelRequestToken) {
        let path = '/v2/admin/get_airlines';
        let headers;
        await this.getAdminTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        if (headers && payload.stage) {
            headers.stage = payload.stage;
        }

        payload = {};

        //return {"data":{"airlines":[{"airline_name":"Aer Lingus","airline_code":"EIN"},{"airline_name":"Aeroflot","airline_code":"AFL"},{"airline_name":"Aerolineas Argentinas","airline_code":"ARG"},{"airline_name":"Aeromexico","airline_code":"AMX"},{"airline_name":"Air Austral","airline_code":"REU"},{"airline_name":"Air Belgium","airline_code":"ABB"},{"airline_name":"Air Canada","airline_code":"ACA"},{"airline_name":"Air Canada Rouge","airline_code":"ROU"},{"airline_name":"Air China","airline_code":"CCA"},{"airline_name":"Air Europa","airline_code":"AEA"},{"airline_name":"Air France","airline_code":"AFR"},{"airline_name":"Air New Zealand","airline_code":"ANZ"},{"airline_name":"Air Serbia","airline_code":"ASL"},{"airline_name":"Air Tahiti Nui","airline_code":"THT"},{"airline_name":"Air Tanzania","airline_code":"ATC"},{"airline_name":"Airbus","airline_code":"AIB"},{"airline_name":"Aircalin","airline_code":"ACI"},{"airline_name":"Alitalia","airline_code":"AZA"},{"airline_name":"All Nippon Airways","airline_code":"ANA"},{"airline_name":"American Airlines","airline_code":"AAL"},{"airline_name":"Arkia Israeli Airlines","airline_code":"AIZ"},{"airline_name":"Avianca","airline_code":"AVA"},{"airline_name":"Avianca Brasil","airline_code":"ONE"},{"airline_name":"Azul Linhas Aereas","airline_code":"AZU"},{"airline_name":"Belavia - Belarusian Airlines","airline_code":"BRU"},{"airline_name":"Biman Bangladesh Airlines","airline_code":"BBC"},{"airline_name":"Boeing Commercial Airplane Group","airline_code":"BOE"},{"airline_name":"British Airways","airline_code":"BAW"},{"airline_name":"Brussels Airlines","airline_code":"BEL"},{"airline_name":"Cathay Pacific","airline_code":"CPA"},{"airline_name":"China Airlines","airline_code":"CAL"},{"airline_name":"China Eastern Airlines","airline_code":"CES"},{"airline_name":"China Southern Airlines","airline_code":"CSN"},{"airline_name":"Copa Airlines","airline_code":"CMP"},{"airline_name":"Crystal AirCruises","airline_code":"C2A"},{"airline_name":"Delta Air Lines","airline_code":"DAL"},{"airline_name":"Dragonair","airline_code":"HDA"},{"airline_name":"EVA Airways","airline_code":"EVA"},{"airline_name":"Edelweiss Air","airline_code":"EDW"},{"airline_name":"Egyptair","airline_code":"MSR"},{"airline_name":"El Al","airline_code":"ELY"},{"airline_name":"Emirates","airline_code":"UAE"},{"airline_name":"Etihad Airways","airline_code":"ETD"},{"airline_name":"Eurowings","airline_code":"EWG"},{"airline_name":"Fiji Airways","airline_code":"FJI"},{"airline_name":"Finnair","airline_code":"FIN"},{"airline_name":"Garuda Indonesia","airline_code":"GIA"},{"airline_name":"Hainan Airlines","airline_code":"CHH"},{"airline_name":"Hawaiian Airlines","airline_code":"HAL"},{"airline_name":"Hong Kong Airlines","airline_code":"CRK"},{"airline_name":"Iberia","airline_code":"IBE"},{"airline_name":"Interjet","airline_code":"AIJ"},{"airline_name":"Japan Airlines","airline_code":"JAL"},{"airline_name":"Jetstar Airways","airline_code":"JST"},{"airline_name":"KLM","airline_code":"KLM"},{"airline_name":"Korean Airlines","airline_code":"KAL"},{"airline_name":"Kuwait Airways","airline_code":"KAC"},{"airline_name":"LAN Airlines","airline_code":"LAN"},{"airline_name":"LEVEL","airline_code":"L5L"},{"airline_name":"Lufthansa","airline_code":"DLH"},{"airline_name":"Malaysia Airlines","airline_code":"MAS"},{"airline_name":"Malindo Air","airline_code":"MXD"},{"airline_name":"Middle East Airlines","airline_code":"MEA"},{"airline_name":"Norwegian Air Shuttle","airline_code":"NAX"},{"airline_name":"PanaSky","airline_code":"PAC"},{"airline_name":"Panasonic Avionics Corporation","airline_code":"P4LL"},{"airline_name":"Philippine","airline_code":"PAL"},{"airline_name":"PleasantonAir","airline_code":"PLA"},{"airline_name":"Presidential Flight Authority","airline_code":"AUH"},{"airline_name":"Qantas","airline_code":"QFA"},{"airline_name":"Qatar","airline_code":"QTR"},{"airline_name":"Qingdao Airlines","airline_code":"QDA"},{"airline_name":"Saudi Aramco","airline_code":"S2A"},{"airline_name":"Saudia Arabian Airlines","airline_code":"SVA"},{"airline_name":"Scoot-Tiger","airline_code":"TGW"},{"airline_name":"SilkAir","airline_code":"SLK"},{"airline_name":"Singapore","airline_code":"SIA"},{"airline_name":"Southwest Airlines","airline_code":"SWA"},{"airline_name":"Swiss International","airline_code":"SWR"},{"airline_name":"Swoop Airlines","airline_code":"WSW"},{"airline_name":"TACA","airline_code":"TAI"},{"airline_name":"TAM","airline_code":"TAM"},{"airline_name":"TAP Portugal","airline_code":"TAP"},{"airline_name":"Thai","airline_code":"THA"},{"airline_name":"Thomsonfly","airline_code":"TOM"},{"airline_name":"Turkish Airlines","airline_code":"THY"},{"airline_name":"Ukraine International Airlines","airline_code":"AUI"},{"airline_name":"United Airlines","airline_code":"UAL"},{"airline_name":"Uzbekistan Airways","airline_code":"UZB"},{"airline_name":"Virgin America","airline_code":"VRD"},{"airline_name":"Virgin Atlantic","airline_code":"VIR"},{"airline_name":"Virgin Australia","airline_code":"VOZ"},{"airline_name":"Vistara","airline_code":"VTI"},{"airline_name":"WestJet Airlines","airline_code":"WJA"}]}};
        //return this.postAdminAxios(path, payload, options, cancelRequestToken);
        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchApps(cancelRequestToken) {
        let path = '/v2/admin/get_apps';
        let headers;
        await this.getAdminTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        let payload = {};

        //return {"data": {"apps": ["Video Games", "SeatBack", "Movies", "", "Audio", "TV Series", "Seatback", "Live TV", "Games"]}};
        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchLicenses(payload, cancelRequestToken) {
        let path = '/v2/admin/get_license_info';
        let headers;
        await this.getAdminTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        if (headers) {
            headers.stage = payload.stage;
            //headers["pac-selected-tenant-icao"] = "ANZ";
        }

        payload = {};

        //return {"data":{"licenses":[{"airline_code":"SIA","airline_name":"Singapore","tiers":[{"subscription_tier":"Basic","stage":null,"license_start_date":"20210401","license_end_date":"20220430","is_active":true},{"subscription_tier":"Standard","stage":"2","license_start_date":"20220201","license_end_date":"20250131","is_active":true}]},{"airline_code":"ETD","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20230531","is_active":true},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210301","license_end_date":"20260430","is_active":true}]},{"airline_code":"ANZ","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20220131","is_active":false},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":true}]},{"airline_code":"QTR","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20230531","is_active":true},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":true}]},{"airline_code":"VOZ","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20220131","is_active":false},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":true}]},{"airline_code":"VTI","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20220131","is_active":false},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":true}]},{"airline_code":"KAL","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20220131","is_active":false},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":true}]},{"airline_code":"THA","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20230531","is_active":true},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":true}]},{"airline_code":"THY","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20220131","is_active":true},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":false}]},{"airline_code":"WJA","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20220131","is_active":false},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":true}]},{"airline_code":"IBE","tiers":[{"subscription_tier":"Basic","stage":1,"license_start_date":"20210601","license_end_date":"20220131","is_active":true},{"subscription_tier":"Standard","stage":"2","license_start_date":"20210501","license_end_date":"20260430","is_active":false}]}]}};
        //return this.postAdminAxios(path, payload, options, cancelRequestToken);
        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchTails(payload, cancelRequestToken) {
        let path = '/v2/admin/get_tails_info';
        let headers;
        await this.getAdminTenantId(payload.icao).then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        if (headers) {
            headers.stage = payload.stage;
        }

        payload = {};

        // todo remove after testing
        // let resp = {"data":{"filter_values":{"systemType":["eX2","eX3","eX2L","eXC","==="],"tails":["P4N44802","P4N62254","P4N97852","P4N62570","P4N64941","P4N88888","9VSMJ","9VSMC","VTTVA","VTTVC"],"apps":["Movies","TV Series","Live TV","Audio","Games","Electronic Reader","Seatback","Portal Navigation","Companion App"],"aircraft_type_subtypes":["B777-300ER","B737-800","B787-9","B787-8","B777-300","A350-900","A380-800","A321-200"]},"tails":[{"airline_code":"PAC","tail_no":"P4N44802","subscription_tier":"Basic","system_type":"eX2","aircraft_type":"B747-800","apps":["Movies","TV Series","Live TV","Audio","Games"]},{"airline_code":"PAC","tail_no":"P4N62254","subscription_tier":"Basic","system_type":"eXC","aircraft_type":"B787-8","apps":["Movies","TV Series","Live TV","Games","Audio","Electronic Reader","Seatback","Portal Navigation","Companion App"]},{"airline_code":"PAC","tail_no":"P4N97852","subscription_tier":"Basic","system_type":"eX2L","aircraft_type":"B777-300","apps":["Movies","TV Series","Live TV","Audio","Games","Portal Navigation"]},{"airline_code":"PAC","tail_no":"P4N62570","subscription_tier":"Standard","system_type":"eX3","aircraft_type":"A350-900","apps":["Movies","TV Series","Live TV","Games","Audio","Electronic Reader","Seatback","Portal Navigation","Companion App"]},{"airline_code":"PAC","tail_no":"P4N64941","subscription_tier":"Standard","system_type":"eX3","aircraft_type":"B787-9","apps":["Movies","TV Series","Live TV","Games","Audio","Electronic Reader","Seatback","Portal Navigation","Companion App"]},{"airline_code":"SIA","tail_no":"9VSMJ","subscription_tier":"Basic","system_type":"eX3","aircraft_type":"B777-300ER","apps":["Movies","TV Series","Live TV","Electronic Reader"]},{"airline_code":"SIA","tail_no":"9VSMC","subscription_tier":"Standard","system_type":"eX2","aircraft_type":"B737-800","apps":["Movies","TV Series","Live TV","Games","Audio","Electronic Reader","Seatback","Portal Navigation","Companion App"]},{"airline_code":"VTI","tail_no":"VTTVA","subscription_tier":"Basic","system_type":"eX3","aircraft_type":"B787-9","apps":["Movies","TV Series","Live TV","Electronic Reader"]},{"airline_code":"VTI","tail_no":"VTTVC","subscription_tier":"Standard","system_type":"eX2","aircraft_type":"A321-200","apps":["Movies","TV Series","Live TV","Games","Audio","Portal Navigation","Companion App"]},{"airline_code":"ETD","tail_no":"A6EIW","subscription_tier":"Standard","system_type":"eX2L","aircraft_type":"B777-300ER","apps":["Movies","TV Series","Live TV","Games","Audio","Portal Navigation"]},{"airline_code":"ETD","tail_no":"A6BLN","subscription_tier":"Basic","system_type":"eX3","aircraft_type":"A321-200","apps":["Movies","TV Series","Live TV","Games","Portal Navigation","Companion App"]},{"airline_code":"ETD","tail_no":"A6BLU","subscription_tier":"Basic","system_type":"eX2","aircraft_type":"A321-200","apps":["Movies","TV Series","Live TV","Audio","Portal Navigation","Companion App"]}]}};
        // if (payload.icao === 'AFL') {
        //     resp = {"data":{"filter_values":{"systemType":["eX2","eX3","eX2L","eXC","==="],"tails":["P4N44802","P4N62254","P4N97852","P4N62570","P4N64941","P4N88888","9VSMJ","9VSMC","VTTVA","VTTVC"],"apps":["Movies","TV Series","Live TV","Audio","Games","Electronic Reader","Seatback","Portal Navigation","Companion App"],"aircraft_type_subtypes":["B777-300ER","B737-800","B787-9","B787-8","B777-300","A350-900","A380-800","A321-200"]},"tails":[{"airline_code":"PAC","tail_no":"P4N44802","subscription_tier":"Basic","system_type":"eX2","aircraft_type":"B747-800","apps":["Movies","TV Series","Live TV","Audio","Games"]},{"airline_code":"PAC","tail_no":"P4N62254","subscription_tier":"Basic","system_type":"eXC","aircraft_type":"B787-8","apps":["Movies","TV Series","Live TV","Games","Audio","Electronic Reader","Seatback","Portal Navigation","Companion App"]},{"airline_code":"PAC","tail_no":"P4N97852","subscription_tier":"Basic","system_type":"eX2L","aircraft_type":"B777-300","apps":["Movies","TV Series","Live TV","Audio","Games","Portal Navigation"]},{"airline_code":"PAC","tail_no":"P4N62570","subscription_tier":"Standard","system_type":"eX3","aircraft_type":"A350-900","apps":["Movies","TV Series","Live TV","Games","Audio","Electronic Reader","Seatback","Portal Navigation","Companion App"]},{"airline_code":"PAC","tail_no":"P4N64941","subscription_tier":"Standard","system_type":"eX3","aircraft_type":"B787-9","apps":["Movies","TV Series","Live TV","Games","Audio","Electronic Reader","Seatback","Portal Navigation","Companion App"]},{"airline_code":"SIA","tail_no":"9VSMJ","subscription_tier":"Basic","system_type":"eX3","aircraft_type":"B777-300ER","apps":["Movies","TV Series","Live TV","Electronic Reader"]},{"airline_code":"SIA","tail_no":"9VSMC","subscription_tier":"Standard","system_type":"eX2","aircraft_type":"B737-800","apps":["Movies","TV Series","Live TV","Games","Audio","Electronic Reader","Seatback","Portal Navigation","Companion App"]},{"airline_code":"VTI","tail_no":"VTTVA","subscription_tier":"Basic","system_type":"eX3","aircraft_type":"B787-9","apps":["Movies","TV Series","Live TV","Electronic Reader"]},{"airline_code":"VTI","tail_no":"VTTVC","subscription_tier":"Standard","system_type":"eX2","aircraft_type":"A321-200","apps":["Movies","TV Series","Live TV","Games","Audio","Portal Navigation","Companion App"]},{"airline_code":"ETD","tail_no":"A6EIW","subscription_tier":"Standard","system_type":"eX2L","aircraft_type":"B777-300ER","apps":["Movies","TV Series","Live TV","Games","Audio","Portal Navigation"]},{"airline_code":"ETD","tail_no":"A6BLN","subscription_tier":"Basic","system_type":"eX3","aircraft_type":"A321-200","apps":["Movies","TV Series","Live TV","Games","Portal Navigation","Companion App"]},{"airline_code":"ETD","tail_no":"A6BLU","subscription_tier":"Basic","system_type":"eX2","aircraft_type":"A321-200","apps":["Movies","TV Series","Live TV","Audio","Portal Navigation","Companion App"]}]}};
        // }
        // return resp;

        //return this.postAdminAxios(path, payload, options, cancelRequestToken);
        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchFlightMetrics(payload) {
        let path = `/v2/metrics/flight_metrics_data`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            body: payload,
            headers: headers
        };

        //console.log("InsightsMonthlyService.js - fetchFlightMetrics - options = " + JSON.stringify(options) + ' , path = ' + path);

        return this.post(this.apiName, path, options);
    }

    async fetchFlightMetricsAxios(payload, cancelRequestToken) {
        let path = `/v2/metrics/flight_metrics_data`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchNextInsightsMetricsAxios(payload, path, cancelRequestToken) {
        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        //console.log("InsightsMonthlyService.js - fetchNextInsightsMetricsAxios - options = " + JSON.stringify(options) + ' , path = ' + path);
        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchEngagementMetricsAxios(payload, cancelRequestToken) {
        let path = `/v2/metrics/engagement_data`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers
        };

        //return {"airline_code":"SIA","requested_sections":{"passenger_engagement":{"total_time":{"data":[{"label":"Movies","value":"76.1","comparison_value":"-2.8","comparison_raw_value":"78.3","nominal_value":"98989876","comparison_nominal_value":"54545454"},{"label":"TV Series","value":"13.8","comparison_value":"-6.1","comparison_raw_value":"14.7","nominal_value":"899999","comparison_nominal_value":"565656565656"},{"label":"Audio","value":"8.3","comparison_value":"62.7","comparison_raw_value":"5.1","nominal_value":"799999","comparison_nominal_value":"23423432"},{"label":"Games","value":"1.2","comparison_value":"-40","comparison_raw_value":"2","nominal_value":"699999","comparison_nominal_value":"676767676"},{"label":"Trailer","value":"0.3","comparison_value":"100","comparison_raw_value":"0","nominal_value":"599999","comparison_nominal_value":"676"},{"label":"Live TV","value":"0.2","comparison_value":"100","comparison_raw_value":null,"nominal_value":"499999","comparison_nominal_value":"67676"},{"label":"Others","value":"0","comparison_value":"0","comparison_raw_value":null,"nominal_value":"399999","comparison_nominal_value":"23"},{"label":"Video","value":"0","comparison_value":"0","comparison_raw_value":null,"nominal_value":"299999","comparison_nominal_value":"656565"}]},"total_views":{"data":[{"label":"Audio","value":"43","comparison_value":"51.4","comparison_raw_value":"28.4","nominal_value":"6768954","comparison_nominal_value":"999998"},{"label":"Movies","value":"32.9","comparison_value":"-33.1","comparison_raw_value":"49.2","nominal_value":"1234","comparison_nominal_value":"999998"},{"label":"TV Series","value":"13.9","comparison_value":"-35.3","comparison_raw_value":"21.5","nominal_value":"2345","comparison_nominal_value":"999998"},{"label":"Others","value":"5.1","comparison_value":"100","comparison_raw_value":null,"nominal_value":"3456","comparison_nominal_value":"999998"},{"label":"Trailer","value":"3.6","comparison_value":"1700","comparison_raw_value":"0.2","nominal_value":"4567","comparison_nominal_value":"999998"},{"label":"Games","value":"1.2","comparison_value":"71.4","comparison_raw_value":"0.7","nominal_value":"5678","comparison_nominal_value":"999998"},{"label":"Live TV","value":"0.3","comparison_value":"100","comparison_raw_value":null,"nominal_value":"6789","comparison_nominal_value":"999998"},{"label":"Video","value":"0","comparison_value":"0","comparison_raw_value":null,"nominal_value":"7891","comparison_nominal_value":"999998"}]}},"ped_vs_seatback":{"total_time":{"data":[{"label":"PED","value":"44","comparison_value":"-45.9","comparison_raw_value":"81.5","nominal_value":"12345","comparison_nominal_value":"234334343343"},{"label":"Seatback","value":"56","comparison_value":"201.7","comparison_raw_value":"18.5","nominal_value":"8765456","comparison_nominal_value":"3434343"}]},"total_views":{"data":[{"label":"PED","value":"20.9","comparison_value":"-64.8","comparison_raw_value":"59.2","nominal_value":"567895","comparison_nominal_value":"1234567"},{"label":"Seatback","value":"79.1","comparison_value":"94","comparison_raw_value":"40.8","nominal_value":"4598765","comparison_nominal_value":"345678"}]}},"portal_device_browser":{"total_counts":{"data":[{"label":"Mobile Safari","value":"66","comparison_value":1,"comparison_raw_value":null},{"label":"Chrome Mobile WebView","value":"10.5","comparison_value":-22,"comparison_raw_value":null},{"label":"Chrome Mobile","value":"8.7","comparison_value":33,"comparison_raw_value":null},{"label":"Chrome Mobile iOS","value":"3.8","comparison_value":44,"comparison_raw_value":null},{"label":"Safari","value":"3.1","comparison_value":null,"comparison_raw_value":null},{"label":"Chrome","value":"2.3","comparison_value":null,"comparison_raw_value":null},{"label":"Samsung Internet","value":"1.3","comparison_value":null,"comparison_raw_value":null},{"label":"Others","value":"4.6","comparison_value":null,"comparison_raw_value":null}]}},"portal_device_os":{"total_counts":{"data":[{"label":"iOS","value":"70.3","comparison_value":0,"comparison_raw_value":null},{"label":"Android","value":"24.3","comparison_value":-10,"comparison_raw_value":null},{"label":"Mac OS X","value":"3.3","comparison_value":12,"comparison_raw_value":null},{"label":"Windows","value":"1","comparison_value":null,"comparison_raw_value":null},{"label":"Others","value":"1","comparison_value":null,"comparison_raw_value":null},{"label":"Linux","value":"0","comparison_value":null,"comparison_raw_value":null}]}}}};
        return this.postAxios(path, payload, options, cancelRequestToken);
    }

    async fetchWorkbenchMetrics(category, year, month) {
        let path = `/metrics/${year}-${month}/${category}/workbench`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = { headers: headers };

        return this.makeGetApiCall(this.apiName, path, options);
    }

    async fetchWorkbenchData(payload, cancelRequestToken) {
        let path = `/v2/metrics/workbench_metrics_data`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = { headers: headers, body: payload, cancelToken: cancelRequestToken };

        return this.postAxios(path, payload, options);
    }

    async fetchFlightsAxios(payload, cancelRequestToken) {
        let path = `/v2/metrics/flight_list_data`;

        let headers;
        await this.getTenantId().then((response) => {
            headers = response;
        });

        let options = {
            headers: headers,
            cancelToken: cancelRequestToken
        };

        if (options.headers) {
            options.headers.Authorization = await this.getAuthorizationHeader();
        }

        //path = process.env.REACT_APP_INSIGHTS_API_URL + path;

        return this.postAxios(path, payload, options);
    }

    async fetchLopa(payload) {
        let path = `/v2/metrics/seat_usage_data`;

        let headers;
        let options = {
            body: payload,
            headers: headers
        };

        await this.getTenantId().then((response) => {
            headers = response;
        });

        options = { headers: headers, body: payload };

        return this.postAxios(path, payload, options, null);
    }

    async fetchFeatureFlags() {
        let path = process.env.REACT_APP_INSIGHTS_API_URL + `/v2/info/feature_flags`;

        let headers;
        try {
            headers = {
                'pac-selected-tenant-icao': 'pac',
                Authorization: await this.getAuthorizationHeader()
            };
        } catch (error) {
            console.log(error);
            return;
        }

        let options = {
            body: {},
            headers: headers
        };

        return new Promise((resolve, reject) => {
            this.makeGetApiCallAxios(path, options).then((response) => {
                if (response) {
                    return resolve(response);
                } else {
                    return reject(response);
                }
            });
        });
    }
}

export default InsightsMonthlyService;
